// extracted by mini-css-extract-plugin
export default {"wrapper":"bE-z","button":"cE-z","alternate":"dE-z","disabled":"eE-z","paymentWarning":"fE-z","fadeIn":"gE-z"};